import { LikeButton } from './components/LikeButton';
import type { GetDiscussionResponse } from './types';
import { routes, Link } from 'wasp/client/router';
import { AuthorByline } from './components/AuthorByline';
import { TagList } from './components/TagPill';
import { BsChat, BsEye } from 'react-icons/bs';

export function DiscussionCard({
  discussion,
  showAuthor = true,
}: {
  discussion: GetDiscussionResponse;
  showAuthor?: boolean;
}) {
  return (
    <Link
      to={routes.DiscussionRoute.to}
      params={{ discussionId: discussion.id }}
      className="block group"
    >
      <div className="rounded-xl border border-neutral-200/60 dark:border-neutral-700/50 p-5 sm:p-6 transition-all duration-200 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5 dark:hover:border-primary/30 bg-white dark:bg-boxdark">
        {/* Header: author + date */}
        {showAuthor && (
          <AuthorByline
            user={discussion.user}
            date={discussion.createdAt}
            showAvatar
            className="mb-3"
          />
        )}

        {/* Title */}
        <h2 className="text-lg font-semibold text-neutral-900 dark:text-white mb-2 group-hover:text-primary transition-colors leading-snug">
          {discussion.title}
        </h2>

        {/* Content preview */}
        <p className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-2 mb-4 leading-relaxed">
          {discussion.content}
        </p>

        {/* Tags */}
        <TagList tags={discussion.tags} className="mb-4" />

        {/* Footer: engagement stats */}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          className="flex items-center gap-3 text-xs text-neutral-400 dark:text-neutral-500 pt-3 border-t border-neutral-100 dark:border-neutral-800/50"
          onClick={(e) => e.preventDefault()}
        >
          <LikeButton
            discussionId={discussion.id}
            isLiked={discussion.isLikedByUser}
            likesCount={discussion._count.likes}
            size="sm"
          />
          <span className="flex items-center gap-1">
            <BsChat className="h-3 w-3" />
            {discussion._count.comments}
          </span>
          <span className="flex items-center gap-1">
            <BsEye className="h-3 w-3" />
            {discussion._count.views}
          </span>
        </div>
      </div>
    </Link>
  );
}
